import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GENERATE_URL: {
		path: 'generate-url',
		method: 'POST'
	},
	COLLECT_BASKET: {
		path: 'collect-basket',
		method: 'GET'
	}
};

export interface IGenerateUrlOptions extends IBaseFetchOptions {
	parameters: IBaseParameters & {
		c_clientId: string
	};
	body: {
		products: Array<{
			productId: string
			quantity?: number
		}>
	};
}

export interface ICollectBasketOptions extends IBaseFetchOptions {
	parameters: IBaseParameters & {
		c_bid:string
	};
}

export interface IGenerateUrlResponse extends IBaseResponse {
	collectBasketURL: string;
}

export interface ICollectBasketResponse extends IBaseResponse {
	redirect: boolean;
	redirectUrl: string;
}
